import { useContext, useState, useEffect } from 'react';
import { useSelector } from "react-redux";
import StripeUrlService from '../../services/stripeUrl';
import {
    Card,
    CardContent,
    Typography,
    Box,
    Button,
    TextField,
    Grid,
    IconButton,
    ToggleButton,
    ToggleButtonGroup,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Skeleton,
    FormControl,
    FormHelperText,
    Link
} from "@mui/material";
import { Add, Remove } from "@mui/icons-material";
import ConfigContext from '../../context/ConfigContext';
import { useTheme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import subscriptionService from '../../services/subscriptionPlan';
import HighlightOffRoundedIcon from '@mui/icons-material/HighlightOffRounded';



const useStyles = makeStyles((theme) => ({
    pricingContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
        marginBottom: theme.spacing(3),
        flexDirection: 'column',
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(2),
        },
    },
    toggleButtonGroup: {
        borderRadius: 50,
        padding: 2,
        background: '#f2f2f2',
        border: '0.5px solid #ddd',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            justifyContent: 'center',
        },
    },
    toggleButton: {
        textTransform: 'none',
        fontWeight: 'bold',
        borderRadius: '50px !important',
        height: 30,
        border: 'none',
        padding: '10px 20px',
        transition: 'background-color 0.3s ease',
        '&:hover': {
            backgroundColor: 'rgba(99, 91, 255, 0.1)',
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: '14px',
            padding: '8px 16px',
        },
    },

    selectedMonthly: {
        color: '#ffffff !important',
        backgroundColor: '#3A2FA0 !important',
    },
    selectedYearly: {
        color: '#ffffff !important',
        backgroundColor: '#3A2FA0 !important',
    },
    entDescription: {
        fontSize: 16,
        fontFamily: 'Poppins, sans-serif',
        marginBottom: '36px',
        lineHeight: '24px',
    },
    entHeading: {
        fontFamily: 'Poppins',
        fontWeight: 700,
        fontSize: '24px',
        lineHeight: '32px',
        letterSpacing: 0,
        color: '#102C72',
        marginBottom: '13px',
    },
    priceChartHeading: {
        fontFamily: 'Poppins',
        fontWeight: 500,
        fontSize: '18px',
        lineHeight: '32px',
        letterSpacing: 0,
        color: '#102C72',
        marginBottom: '14px',
    },
    spaceBetweenContentAndPriceCard: {
        minWidth: '520px',
    },
    priceCard: {
        borderRadius: 5,
        padding: 0,
        border: '1px solid #4497F7',
        justifyContent: 'space-between',
        // height: '100%',
        height: 527,
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            padding: theme.spacing(2),
        },
    },
    priceCardBody: {
        height: '100%',
        padding: '0 44px',
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column',
        gap: '36px',
        justifyContent: 'center'
    },
    priceTable: {
        backgroundColor: '#f3f4f6',
        padding: theme.spacing(4),
        borderRadius: '12px',
        width: '100%',
        boxSizing: 'border-box',
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(2),
        },
    },
    tableCell: {
        border: 'none',
        padding: '6.4px 42px',
        fontWeight: '500',
        fontSize: '14px',
        lineHeight: "24px",
        background: '#F4F4F4',
        [theme.breakpoints.down('sm')]: {
            fontSize: '12px',
            padding: '8px',
        },
    },
    entDesclaimer: {
        marginTop: '10px',
    },
    updateButton: {
        textTransform: 'none',
        borderRadius: 4,
        backgroundColor: '#3a2fa0',
        color: '#fff',
        marginBottom: theme.spacing(2),
        '&:hover': {
            backgroundColor: '#32288f',
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: '14px',
            padding: '8px 12px',
        },
    },
    totalText: {
        fontWeight: '700',
        color: '#102C72',
        fontSize: '34px',
        display: 'flex',
        gap: '6px',
        lineHeight: '32px',
        textAlign: 'left',
        marginBottom: 0,
        [theme.breakpoints.down('sm')]: {
            fontSize: '16px',
        },
    },
    subscribeButton: {
        textTransform: 'none',
        borderRadius: 30,
        fontWeight: 'bold',
        width: 'max-content',
        padding: '10px 71px',
        fontSize: '14px',
        backgroundColor: '#102C72',
        gap: theme.spacing(1),
        color: '#fff',
        transition: 'background-color 0.3s ease',
        '&:hover': {
            backgroundColor: '#32288f',
        },
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(1.5, 3),
            fontSize: '14px',
        },
    },
    quantityBox: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: theme.spacing(1),
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            gap: theme.spacing(0.5),
        },
    },
    inputField: {
        textAlign: 'center',
        width: '60px',
        fontSize: '16px',
        [theme.breakpoints.down('sm')]: {
            width: '50px',
            fontSize: '14px',
        },
    },
    formControl: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        marginBottom: '15px',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },
    inputWrapper: {
        display: 'flex',
        alignItems: 'center',
        maxWidth: 200,
        gap: '19px',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            gap: theme.spacing(0.5),
        },
    },
    // inputQuantityField:{
    //     border: '1px solid #4497F7',
    // },
    inputBtn: {
        background: '#102C72',
        borderRadius: '50%',
        color: '#fff',
        '&:hover': {
            background: '#1c3d90',
        }
    },
    helperTextContainer: {
        fontSize: '11px',
        background: '#fafafa',
        display: 'flex',
        alignItems: 'center',
        border: '1px solid #ec0018',
        borderLeft: '9px solid #ec0018',
        borderRadius: '5px',
        gap: '15px',
        padding: '9px 15px'
    },
    helperTextContent: {
        color: '#ec0018',
        letterSpacing: '1px', 
        wordSpacing: '0.5px',
        fontSize: '10px'
    },
    quantityLabel: {
        padding: '7.6px 24px',
        borderBottom: '1px solid #4497F7',
        borderRadius: 5,
    },
    selectText: {
        fontFamily: 'Poppins, sans-serif',
        fontWeight: 500,
        fontSize: '14px',
        lineHeight: '32px',
    },
    totalContainer: {
        opacity: 0,
        display: 'none',
        transform: 'translateY(-10px)',
        transition: 'opacity 0.3s ease, transform 0.3s ease',
    },
    lineThrough: {
        textDecoration: 'line-through'
    },
    boldText: {
        fontWeight: 'bold',
    },
    priceToggleButtonGroup: {
        background: '#E1E3EA',
        borderRadius: '60px',
        margin: '12px 0 24px 0',
        border: '1.5px solid #D7CFE3',
        color: '#4F5050'
    },
    priceToggleButton: {
        border: 'none',
        borderRadius: '60px 60px 60px 60px !important',
        flexDirection: 'column',
        padding: '16px 56px',
        maxWidth: '216px',
        textTransform: 'none'
    },
    priceDetailsBox: {
        width: '100%',
        display: 'flex',
    },
    totalContainerVisible: {
        opacity: 1,
        display: 'flex',
        gap: '6px',
        marginBottom: '0.5rem',
        transform: 'translateY(0)',
        // justifyContent: 'start',
        alignItems: 'center',
    },
    priceDetails: {
        display: 'inline-block',
        opacity: 1,
        whiteSpace: 'nowrap',
        fontSize: '14px',
        color: '#102C72',
    },
    perText: {
        color: theme.palette.text.secondary,
        fontSize: 11,
        textAlign: 'left',
        maxWidth: '40px',
        lineHeight: '16.5px',
    },
    slideButton: {
        transform: 'translateY(10px)',
        position: 'absolute',
    },

    emailLink: {
        fontSize: '14px',
        color: theme.palette.primary.main,
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
    cardWrapper: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '63px',
        width: '100%',
        backgroundColor: '#F7F7F7',
        borderRadius: 30,
        padding: '37px 72px 8px 73px',
        border: '0.5px solid #ddd',
        minWidth: '1306px',
    },
    contentBox: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    },

    toggleButtonHeading: {
        fontSize: '14px',
        fontWeight: '700',
        lineHeight: '21px',
    },

    toggleButtonContent: {
        fontSize: '11px',
        color: '#000',
        lineHeight: '16.5px'
    },
    selectedPriceYearly: {
        background: '#ffffff !important',
        border: '1.5px solid #102C72 !important',
        color: '#102C72 !important',
    },
    selectedPriceMonthly: {
        background: '#ffffff !important',
        border: '1.5px solid #102C72 !important',
        color: '#102C72 !important',
    }
}));


export default function StripePricingTable() {

    const config = useContext(ConfigContext);
    const user = useSelector(state => state.auth.user);
    const [subscriptions, setSubscriptions] = useState([]);
    const [enterpriseName, setEnterpriseName] = useState('')
    const [enterpriseDescription, setEnterpriseDescription] = useState('')
    const [montlyPricing, setMonthlyPricing] = useState([])
    const [yearlyPricing, setYearlyPricing] = useState([])
    const [pricingTableData, setPricingTableData] = useState([])
    const [quantity, setQuantity] = useState('');
    const [billingCycle, setBillingCycle] = useState("monthly");
    const [loading, setLoading] = useState(true)
    const [maxQuantity, setMaxQuantity] = useState(null)
    const [minQuantity, setMinQuantity] = useState(null)
    const [monthlyTier, setMonthlyTier] = useState([])
    const [yearlyTier, setYearlyTier] = useState([])
    const [totalPrice, setTotalPrice] = useState(0)
    const [isPriceUpdated, setIsPriceUpdated] = useState(true)
    const [paymentUrl, setPaymentUrl] = useState('')
    const [priceId, setPriceId] = useState('')
    const [pricing, setPricing] = useState(0)
    const [discount, setDiscount] = useState(null)
    const [showPricingData, setShowPricingData] = useState([])
    const [discountedMonthPrice, setDiscountedMonthPrice] = useState(0)

    const theme = useTheme();
    const classes = useStyles();

    useEffect(() => {
        const loadSubscriptions = async () => {
            try {

                const data = await subscriptionService.getSubscriptionsByStatus("active");
                setEnterpriseName(data.items[0].title)
                setEnterpriseDescription(data.items[0].description)

                const monthlyTiers = data.items.filter((value) => {
                    return value.term == 'monthly'
                })



                setPricingTableData(JSON.parse(monthlyTiers[0].tiers))
                setShowPricingData(JSON.parse(monthlyTiers[0].tiers))
                setMonthlyTier(monthlyTiers)
                setMaxQuantity(monthlyTiers[0].maxQuantity)
                setMinQuantity(monthlyTiers[0].minQuantity)
                setPriceId(monthlyTiers[0].stripePriceId)
                setMonthlyPricing(JSON.parse(monthlyTiers[0].tiers))
                initialPricingDisplay(monthlyTiers[0].minQuantity)





                const yearlyTiers = data.items.filter((value) => {
                    return value.term == 'yearly'
                })

                setYearlyPricing(JSON.parse(yearlyTiers[0].tiers))
                setYearlyTier(yearlyTiers)
                setSubscriptions(data);
            } catch (err) {
                console.log(err)
            } finally {
                setLoading(false)
            }
        };

        loadSubscriptions();
    }, []);

    useEffect(() => {
        if (quantity > 0) {
            showTotalPrice(quantity);
        }
    }, [billingCycle, quantity, minQuantity, totalPrice, pricing, discountedMonthPrice]);





    const handleQuantityChange = (value) => {

        showTotalPrice(value)
    };

    const initialPricingDisplay = (quant) => {

        showTotalPrice(quant)


    }



    //helper function to calculate and show the total price 
    const showTotalPrice = (value) => {

        if (value >= minQuantity) {
            setQuantity(value);
            let unitPriceForRange, totalPrice, discount;
            if (billingCycle === 'monthly') {
                unitPriceForRange = getPricePerUnit(value, montlyPricing);
                setDiscountedMonthPrice((value * unitPriceForRange).toFixed(2))
                const perYearPrice = (value * unitPriceForRange).toFixed(2) * 12
                setTotalPrice(perYearPrice)
                setDiscount("0.00"); // No discount for monthly
                setPricing(unitPriceForRange);
            } else if (billingCycle === 'yearly') {
                unitPriceForRange = getPricePerUnit(value, yearlyPricing);
                totalPrice = (value * unitPriceForRange);
                discount = totalPrice * 0.10;
                const discountedTotalPrice = totalPrice - discount;
                const monthlyPrice = discountedTotalPrice / 12
                setDiscountedMonthPrice(monthlyPrice.toFixed(2))
                setTotalPrice(discountedTotalPrice.toFixed(2))
                setPricing(unitPriceForRange)
                setDiscount(totalPrice.toFixed(2));
            }

        }else{  
                setQuantity(value);
                setDiscountedMonthPrice('0')
                setTotalPrice('0')
                setPricing('0')
                setDiscount('0');
        }
    };




    //helper function to set the billing cycle and billing cycle change 
    const handleBillingCycleNewChange = (event, newCycle) => {
        if (!newCycle || billingCycle === newCycle) return;

        setBillingCycle(newCycle);

        const isMonthly = newCycle === 'monthly';
        const pricingData = isMonthly ? montlyPricing : yearlyPricing;
        const tierData = isMonthly ? monthlyTier[0] : yearlyTier[0];

        setPricingTableData(pricingData);
        setShowPricingData(pricingData);
        setMinQuantity(tierData.minQuantity);
        setMaxQuantity(tierData.maxQuantity);
        setPriceId(tierData.stripePriceId);
        setEnterpriseDescription(tierData.description)

        if (quantity < tierData.minQuantity) { showTotalPrice(tierData.minQuantity) }
        else { showTotalPrice(quantity); }
    };

    //this gets the per unit price of a report 
    const getPricePerUnit = (quantity, termPericeTable) => {
        const range = termPericeTable.find(range => quantity >= range.min && quantity <= range.max);
        return range ? range.price : 0;
    };


    //this handles input change and validations 
      const handleInputChange = (event) => {
        let value = event.target.value;
    
        value = value.replace(/^0+/, '') || '0';
    
        if (/^\d*$/.test(value)) {
            setQuantity(value === "0" ? "" : Number(value)); 
            showTotalPrice(Number(value));
            setIsPriceUpdated(true);
        }
    };
    

    //this function helps in moving qunatity to stripe
    const handleSubscribe = async () => {

        if (isPriceUpdated) {
            try {
                const stripePriceId = priceId;
                const Quantity = String(quantity);
                const email = user.email;
                const stripeBillingCycle = billingCycle

                const response = await StripeUrlService.getPaymentUrl(stripePriceId, Quantity, email, stripeBillingCycle);

                const parsedResponse = JSON.parse(response);

                const paymentUrl = parsedResponse.body.session.url;


                if (paymentUrl) {
                    setPaymentUrl(paymentUrl);
                    window.location.href = paymentUrl;
                } else {
                    console.error("No session URL found in the response");
                }
            } catch (error) {
                console.error('Payment initiation failed', error);
            }
        }
    };





    return (
        <>
            <Grid container>
                <Box className={classes.pricingContainer}>
                </Box>

                {loading ? (
                    <Grid item xs={12}>
                        <Skeleton variant="rectangular" />
                    </Grid>
                ) : (
                    <Box sx={{ position: "relative" }}>
                        <Box className={classes.cardWrapper}>
                            <Box className={classes.contentBox}>
                                <Typography className={classes.entHeading} variant="h5" fontWeight="bold" mb={1}>
                                    {enterpriseName}
                                </Typography>
                                <Typography variant="body1" mb={2} className={classes.entDescription}>
                                    {enterpriseDescription}
                                </Typography>


                                <Typography className={classes.priceChartHeading} variant="body1" fontWeight="bold" mb={2}>
                                    Price Chart {`${billingCycle === 'monthly' ? '(Monthly)' : '(Yearly)'}`}
                                </Typography>

                                <Table>
                                    <TableHead>
                                        <TableRow sx={{ border: '1px solid #102C72' }}>
                                            <TableCell sx={{ fontWeight: '500', border: "none", padding: "6px 42px", background: "#fff", color: "#102C72" }}>
                                                Quantity
                                            </TableCell>
                                            <TableCell sx={{ fontWeight: '500', border: "none", width: '210px', padding: "6px 42px", background: "#fff", color: "#102C72" }}>
                                                Price{" "}
                                                <Typography component="span" sx={{ fontWeight: "500", fontSize: '14px', color: "#888888" }}>
                                                    (Per Report)
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {showPricingData.map((data, index) => (
                                            <TableRow key={index}>
                                                <TableCell className={classes.tableCell} sx={{ fontWeight: 'bold' }}>
                                                    {`${data.min}-${data.max}`}
                                                </TableCell>
                                                <TableCell align="center" className={classes.tableCell}>
                                                    A${data.price}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                                <Typography className={classes.entDesclaimer}>
                                    For plans requiring more than {maxQuantity} reports, please reach out to{" "}
                                    George Haramis at{" "}
                                    <Link
                                        href="mailto:george@moneygps.com.au"
                                        color="primary"
                                        underline="hover"
                                        className={classes.emailLink}
                                    >
                                        george@moneygps.com.au
                                    </Link>
                                </Typography>
                            </Box>
                            <Box className={classes.spaceBetweenContentAndPriceCard} mb={3}>
                                <Card className={classes.priceCard}>
                                    <Box className={classes.quantityLabel}>
                                        <Typography className={classes.selectText} variant="body2">Select Quantity</Typography>
                                    </Box>
                                    <CardContent className={classes.priceCardBody}>
                                        <Box>
                                            <Box className={classes.formControl}>
                                                <Typography
                                                    variant="body1"
                                                    fontSize={25}
                                                    className={` ${classes.totalText}`}
                                                >
                                                    {`A$${discountedMonthPrice}`}
                                                    <Typography component="span" className={classes.perText}>
                                                        Per <br /> month
                                                    </Typography>
                                                </Typography>
                                                <Box className={classes.inputWrapper}>
                                                    <IconButton
                                                        className={classes.inputBtn}
                                                        size="small"
                                                        onClick={() => handleQuantityChange(quantity - 1)}
                                                        disabled={quantity <= minQuantity}
                                                    >
                                                        <Remove />
                                                    </IconButton>

                                                    <TextField
                                                        className={classes.inputQuantityField}
                                                        variant="outlined"
                                                        size="small"
                                                        value={quantity}
                                                        onChange={handleInputChange}
                                                        error={quantity !== "" && (quantity < minQuantity || quantity > maxQuantity)}
                                                        inputProps={{
                                                            inputMode: "numeric",
                                                            pattern: "[0-9]*",
                                                            min: minQuantity,
                                                            max: maxQuantity,
                                                        }}
                                                    />

                                                    <IconButton
                                                        className={classes.inputBtn}
                                                        size="small"
                                                        onClick={() => handleQuantityChange(Number(quantity) + 1)}
                                                        disabled={quantity >= maxQuantity}
                                                    >
                                                        <Add />
                                                    </IconButton>
                                                </Box>
                                            </Box>

                                            <Box className={classes.priceDetailsBox}>
                                                <Typography
                                                    variant="body1"
                                                    fontWeight="300"
                                                    align="center"
                                                    component="span"
                                                    className={`${classes.totalContainer} ${isPriceUpdated ? classes.priceDetails : ""}`}
                                                >
                                                    {`Billed at ( ${quantity===''? 0 : quantity} x A$${pricing} )`} &nbsp; </Typography>
                                                {discount != '0.00' && <Typography component="span" className={`${classes.totalContainer} ${isPriceUpdated ? classes.priceDetails : ""} ${classes.lineThrough}`}> {discount} </Typography>}
                                                <Typography component="span" className={`${classes.totalContainer} ${isPriceUpdated ? classes.priceDetails : ""} ${classes.boldText}`}> &nbsp;{`A$${totalPrice} per year`}</Typography>
                                            </Box>
                                        </Box>
                                        {quantity > maxQuantity && <Box className={classes.helperTextContainer}>
                                            <HighlightOffRoundedIcon sx={{ fontSize: '31px', color: '#ec0018' }} />
                                            {quantity !== "" && (quantity < minQuantity || quantity > maxQuantity) && (
                                                <FormHelperText error>
                                                    {quantity > maxQuantity ? (
                                                        <Typography
                                                            variant="body2"
                                                            component="span"
                                                            className={classes.helperTextContent}
                                                        >
                                                            For plans requiring more than {maxQuantity} reports, please reach out to{" "}
                                                            George Haramis at{" "}george@moneygps.com.au
                                                            {/* <Link
                                                                    href="mailto:george@moneygps.com.au"
                                                                    color="primary"
                                                                    underline="hover"
                                                                    className={classes.emailLink}
                                                                >
                                                                    george@moneygps.com.au
                                                                </Link> */}
                                                        </Typography>
                                                    ) : (
                                                        <Typography
                                                            variant="body2"
                                                            component="span"
                                                            className={classes.helperTextContainer}
                                                        >
                                                            Quantity must be between {minQuantity} and {maxQuantity}
                                                        </Typography>
                                                    )}
                                                </FormHelperText>
                                            )}
                                        </Box>}
                                        <Box display="flex" flexDirection="column" alignItems="center" gap={isPriceUpdated ? 2 : 0}>

                                            <Box>

                                                {isPriceUpdated && <ToggleButtonGroup
                                                    value={billingCycle}
                                                    exclusive
                                                    onChange={handleBillingCycleNewChange}
                                                    className={classes.priceToggleButtonGroup}
                                                >
                                                    <ToggleButton
                                                        value="monthly"
                                                        className={`${classes.priceToggleButton} ${billingCycle === "monthly" ? classes.selectedPriceMonthly : ""}`}
                                                    >
                                                        <Typography className={classes.toggleButtonHeading}>Pay Monthly</Typography>
                                                        <Typography className={classes.toggleButtonContent}>commit monthly</Typography>

                                                    </ToggleButton>
                                                    <ToggleButton
                                                        value="yearly"
                                                        className={`${classes.priceToggleButton} ${billingCycle === "yearly" ? classes.selectedPriceYearly : ""}`}
                                                    >
                                                        <Typography className={classes.toggleButtonHeading}>Pay Upfront save 10% </Typography>
                                                        <Typography className={classes.toggleButtonContent}>commit anually</Typography>
                                                    </ToggleButton>
                                                </ToggleButtonGroup>}
                                            </Box>

                                            <Button
                                                variant="contained"
                                                color="primary"
                                                fullWidth
                                                onClick={handleSubscribe}
                                                className={`${classes.subscribeButton}`}
                                                disabled={quantity < minQuantity || quantity > maxQuantity}
                                            >
                                                Start trial
                                            </Button>
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Box>
                        </Box>
                    </Box>
                )}
            </Grid>


        </>
    );
}
